import {RecordAuditDefinitionResponseBody} from '@dms/api/core';

import {RecordAuditDefinitionFormValue} from '../types/RecordAuditDefinitionFormValue';
import {orderTasksForDisplay} from './taskListOperations';

export const toRecordAuditDefinitionFormValue = (
  data: RecordAuditDefinitionResponseBody
): RecordAuditDefinitionFormValue => {
  const sections = (data.sections ?? []).map((section) => ({
    id: section.id,
    name: section.name,
  }));

  return {
    name: data.name,
    resourceIds: data.resourceIds,
    description: data.description,
    category: data.category,
    successThreshold: data.successThreshold,
    sections,
    tasks: orderTasksForDisplay(
      data.tasks.map((task) => ({
        id: task.id,
        description: task.description,
        isMandatory: task.isMandatory,
        fileRequired: task.fileRequired,
        weight: task.weight ?? 1,
        sectionId: task.sectionId ?? null,
      })),
      sections
    ),
  };
};
